import type { FaultEvent } from "../../../../api/useFaultEvents";
import t from "../../../../i18n";

export const computeDetectionType = ({
  areAllFaultsConfirmed,
  areAllDetectionsFalse,
}: {
  areAllFaultsConfirmed: boolean;
  areAllDetectionsFalse: boolean;
}): boolean | null => (areAllFaultsConfirmed ? true : areAllDetectionsFalse ? false : null);

export const getFaultEventDetectionText = (detection: Exclude<FaultEvent["detection"], null>) => {
  switch (detection) {
    case true:
      return t("project.fault_event.detection.true");
    case false:
      return t("project.fault_event.detection.false");
    default:
      throw new Error(detection satisfies never);
  }
};
